// extracted by mini-css-extract-plugin
module.exports = {"flipTools":"FlipTools_flipTools__2LZFd"};